import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import { getLogEntries } from '../redux/logEntrySlice';
import { EyeIcon } from '@heroicons/react/16/solid';
import LogEntriesDetailModal from '../components/LogEntriesDetailModal';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const LogEntryList = () => {
    const dispatch = useDispatch();
    const { logEntries, status } = useSelector((state) => state.logEntries);
    const { filterData } = useSearchExport();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLogEntries, setSelectedLogEntries] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const logEntriesPerPage = 50;

    useEffect(() => {
        dispatch(getLogEntries());  // Fetch all open calls on component load
    }, [dispatch]);

    const handleRowClick = (logEntry) => {
        setSelectedLogEntries(logEntry);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedLogEntries(null);
    };

    const currentlogEntries = filterData(logEntries)
        .slice((currentPage - 1) * logEntriesPerPage, currentPage * logEntriesPerPage);

    return (
        <div className="container mx-auto p-6">

            {/* Render the loader if the status is 'idle' */}
            {status === 'idle' && <RecordsLoader text="Loading Logs, please hold on..." />}

            <h1 className="text-2xl text-black font-bold mb-6">Log Entry List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={logEntries} fileName="logs" />

            {status === 'failed' && <p>Error loading logEntries</p>}

            {/* Open Call List Table */}
            {status === 'succeeded' && (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">ID</th>
                                <th className="px-4 py-2">Error Type</th>
                                <th className="px-4 py-2">User Email</th>
                                <th className="px-4 py-2">Endpoint</th>
                                <th className="px-4 py-2">User IP</th>
                                <th className="px-4 py-2">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentlogEntries.length > 0 ? (
                                currentlogEntries.map((logEntry) => (
                                    <tr
                                        key={logEntry.id}
                                        className="border-b cursor-pointer hover:bg-gray-100"
                                    >
                                        <td className="px-4 py-2">{logEntry.id}</td>
                                        <td>
                                            <span className={`inline-block px-4 rounded-full ${logEntry.level === "ERROR" ? "bg-red-500 text-white" : logEntry.level === "INFO" ? "bg-yellow-500 text-black" : "bg-gray-500 text-black"}`}>
                                                {logEntry.level}
                                            </span>
                                        </td>
                                        <td className="px-4 py-2">{logEntry.user_email}</td>
                                        <td className="px-4 py-2">{logEntry.endpoint}</td>
                                        <td className="px-4 py-2">{logEntry.user_ip}</td>
                                        <td className="px-4 py-2 flex">
                                            <EyeIcon className="size-6 text-blue-500 ml-4" onClick={() => handleRowClick(logEntry)} />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4">No logEntries Found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Open Call Detail Modal */}
                    <LogEntriesDetailModal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        logEntry={selectedLogEntries}
                    />

                    {/* Pagination */}
                    {logEntries.length > logEntriesPerPage && (
                        <Pagination
                            usersPerPage={logEntriesPerPage}
                            totalUsers={logEntries.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default LogEntryList;